var dayjs = require('dayjs')
const formatDateHour = {
    install(Vue) {
        Vue.filter('formatDateHour', (value) => {

            let result = `${ dayjs(value).format('DD/MM/YYYY') } às ${ dayjs(value).format('HH:mm') }`
            return result
        });
    },
};

export default formatDateHour